import { t } from "@lingui/macro";
import { basicsSchema } from "@reactive-resume/schema";
import { Input, Label, Tooltip } from "@reactive-resume/ui";

import { useResumeStore } from "@/client/stores/resume";

import { CustomFieldsSection } from "./custom/section";
import { PictureSection } from "./picture/section";
import { getSectionIcon } from "./shared/section-icon";
import { useBuilderStore } from "@/client/stores/builder";
import { URLInput } from "./shared/url-input";
import { useEffect, useState } from "react";
import { ZodError } from "zod";
import { Checkbox } from "@reactive-resume/ui";

export const BasicsSection = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const basics = useResumeStore((state) => state.resume.data.basics);

  const [validationErrors, setValidationErrors]: any = useState({});
  const Client_Id = useResumeStore((state) => state.resume.client_id);
  useEffect(() => {
    setValue("basics.client_id", Client_Id);
  }, [Client_Id, setValue]);

  useEffect(() => {
    try {
      basicsSchema.parse(basics);
      setValidationErrors({});
    } catch (error: any) {
      if (error instanceof ZodError) {
        const errors = error.errors.reduce((acc: any, err) => {
          acc[err.path[0]] = err.message;
          return acc;
        }, {});
        setValidationErrors(errors);
      } else {
        console.error("Unexpected error during validation:", error.message);
      }
    }
  }, [basics]);
  return (
    <section id="basics" className="grid gap-y-6">
      <header className="flex items-center justify-between" style={{ marginTop: "30px" }}>
        <div className="flex items-center gap-x-4">
          {getSectionIcon("basics")}
          <h2 className="line-clamp-1 text-3xl font-bold">Basic Details</h2>
        </div>
      </header>

      <main className="grid gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <PictureSection />
        </div>

        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor="basics.name">{t`Full Name`}</Label>
          <Input
            id="basics.name"
            value={basics.name}
            className="disabled:opacity-100"
            disabled={basics.name !== ""}
            hasError={!basicsSchema.pick({ name: true }).safeParse({ name: basics.name }).success}
            onChange={(event) => setValue("basics.name", event.target.value)}
          />
        </div>

        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor="basics.headline">
            Resume Title{" "}
            <Tooltip content={t`Resume Title`}>
              <i className="fas fa-info-circle text-orange-500"></i>
            </Tooltip>
          </Label>
          <Input
            id="basics.headline"
            value={basics.headline}
            onChange={(event) => setValue("basics.headline", event.target.value)}
            // hasError={
            //   !basicsSchema.pick({ headline: true }).safeParse({ headline: basics.headline })
            //     .success
            // }
            // errormsg={validationErrors.headline}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="basics.email">{t`Email`}</Label>
          <Input
            id="basics.email"
            placeholder="john.doe@example.com"
            className="disabled:opacity-100"
            value={basics.email}
            // hasError={
            //   !basicsSchema.pick({ email: true }).safeParse({ email: basics.email }).success
            // }
            onChange={(event) => setValue("basics.email", event.target.value)}
            // errormsg={validationErrors.email}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="basics.phone">Mobile</Label>
          <Input
            id="basics.phone"
            placeholder="9999999999"
            className="disabled:opacity-100"
            value={basics.phone}
            type="number"
            max={9999999999}
            size={10}
            hasError={
              !basicsSchema.pick({ phone: true }).safeParse({ phone: basics.phone }).success
            }
            onChange={(event) => {
              if (event.target.value.length <= 10) {
                setValue("basics.phone", event.target.value);
              } else {
                return false;
              }
            }}
          />
        </div>

        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor="basics.location">Address</Label>
          <Input
            id="basics.location"
            value={basics.location}
            className="disabled:opacity-100"
            disabled={basics.location.length > 100}
            onChange={(event) => setValue("basics.location", event.target.value)}
          />
        </div>

        <div className="space-y-1.5 sm:col-span-2">
          <Label htmlFor="basics.url">MyBharat Public Profile</Label>
          <URLInput
            id="basics.url"
            value={basics.url}
            disabled={true}
            displayLabel="none"
            placeholder="https://example.com"
            onChange={(value) => setValue("basics.url", value)}
          />
        </div>

        <CustomFieldsSection className="sm:col-span-2" />
      </main>
    </section>
  );
};
